import * as t from 'io-ts';

import {makeApiSerializableType} from './apiTypes';
import {parseUploadedAttachment, RAttachment} from './attachmentModel';

/*
 * Runtime type.
 */

const RVacationResponderDirty = t.readonly(
  t.type({
    id: t.number,
    namespace: t.string,
    url: t.string,
    name: t.string,
    body: t.string,
    isEnabled: t.boolean,
    onlyContacts: t.boolean,
    startAt: t.number,
    endAt: t.union([t.null, t.number]),
    channelIds: t.readonlyArray(t.number),
    attachments: t.readonlyArray(RAttachment),
    updatedAt: t.number,
  }),
);

/*
 * Type.
 */

export interface VacationResponderModel extends t.TypeOf<typeof RVacationResponderDirty> {}
export const RVacationResponder = t.clean<VacationResponderModel>(RVacationResponderDirty as any);

/*
 * IO methods.
 */

export function parseVacationResponder(src: any): VacationResponderModel {
  return {
    id: src.id,
    namespace: src.namespace,
    url: src.url,
    name: src.name,
    body: src.body,
    isEnabled: src.enabled,
    onlyContacts: src.only_contacts,
    startAt: src.start_at,
    endAt: src.end_at,
    channelIds: src.channel_ids,
    attachments: src.attachments && src.attachments.map(parseUploadedAttachment),
    updatedAt: src.updated_at,
  };
}

export function serializeVacationResponder(src: VacationResponderModel): any {
  return {
    id: src.id,
    namespace: src.namespace,
    url: src.url,
    name: src.name,
    body: src.body,
    enabled: src.isEnabled,
    only_contacts: src.onlyContacts,
    start_at: src.startAt,
    end_at: src.endAt,
    channel_ids: src.channelIds,
    attachments: src.attachments,
  };
}

/*
 * API type.
 */

export const ApiVacationResponder = makeApiSerializableType(
  'vacationResponder',
  RVacationResponder,
  parseVacationResponder,
  serializeVacationResponder,
);
